import { useEffect, useRef } from "react";
import { useSite } from "../context/SiteContext";
import { api } from "../lib/api";

export const SHORT_MSG = "Hi StripWise, I'd like a free quote";

export const shortTarget = (kind, c) => {
  const enc = encodeURIComponent(SHORT_MSG);
  if (kind === "whatsapp") return `https://wa.me/${c.whatsapp_raw}?text=${enc}`;
  if (kind === "text") return `sms:${c.phone_raw}?&body=${enc}`;
  return `tel:${c.phone_raw}`;
};

export default function ShortLink({ kind }) {
  const { rawContent } = useSite();
  const done = useRef(false);
  useEffect(() => {
    if (!rawContent || done.current) return;
    done.current = true;
    let left = false;
    const go = () => { if (!left) { left = true; window.location.replace(shortTarget(kind, rawContent)); } };
    api.post("/track/contact", { type: kind, place: "short_link", page: window.location.pathname, vid: localStorage.getItem("sw_vid") || "" })
      .catch(() => {}).finally(go);
    setTimeout(go, 1200);
  }, [rawContent, kind]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white" data-testid="short-link-redirect">
      <img src="/logo.png" alt="StripWise" className="h-12 animate-pulse" />
      <p className="text-[#3d504d]">Opening…</p>
    </div>
  );
}
